import React from "react";

const NewsCard = ({ image, tag, title, content }) => {
  return (
    <article className="panel news-card">
      {image ? (
        <img src={image} className="news-img" />
      ) : (
        <div className="news-thumb">PLACEHOLDER — Image</div>
      )}
      <div className="news-copy">
        <span className="tag">{tag}</span>
        <h3>{title}</h3>
        <p>{content}</p>
        <a href="#" className="readmore">
          Read article →
        </a>
      </div>
    </article>
  );
};

export default NewsCard;
